// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const grayContainerWithBorder = ({ isTabletOrMobile }) => {
    return {
        border: 'solid 1px',
        borderColor: 'info.main',
        backgroundColor: 'info.light',
        borderRadius: '.5rem',
        justifySelf: isTabletOrMobile ? 'start' : 'end',
        margin: {
            desktop: isTabletOrMobile ? '1rem 0' : '7px 0',
        },
        padding: '1rem 2rem',
        width: '100%',
        maxWidth: {
            desktop: '381px',
        },
    };
};
const progressMobileContainer = {
    width: '100%',
};
const notificationBody = {
    width: { mobile: '100%' },
    textAlign: 'left',
    mt: {
        desktop: '0.5rem',
    },
    mb: {
        desktop: '0.5rem',
    },
};
const iconContainer = {
    mr: {
        mobile: '0.5rem',
    },
    '& > div > div': {
        padding: 0,
    },
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const card = ({ isTablet, isCarousel, isComplexCard }) => {
    return {
        display: 'grid',
        mb: 0,
        gap: {
            desktop: '0.25rem',
            mobile: '.5rem',
        },
        minHeight: {
            mobile: '230px',
        },
        gridTemplateColumns: {
            desktop: isTablet ? '1fr' : isComplexCard ? '1.3fr 1fr 66px' : '1fr 20px 66px',
            mobile: '1fr ',
        },
        ...(isCarousel && { height: '99%' }),
        gridAutoFlow: 'row',
        '& > .MuiBox-root:nth-of-type(1) ': {
            display: 'grid',
            /* gridTemplateColumns: {
              mobile: '2fr',
            },*/
            gridTemplateRows: {
                desktop: '25px',
            },
            alignItems: {
                mobile: 'start',
                desktop: 'center',
            },
        },
        '& .MuiTypography-root': {
            lineHeight: '25px',
        },
        '& .MuiLink-root': {
            whiteSpace: 'nowrap',
        },
        borderRadius: isCarousel ? 'none' : '8px',
        boxShadow: isCarousel ? 'none' : `0px 4px 10px 0px rgba(0, 0, 0, 0.20)`,
        border: isCarousel ? 'none' : `2px solid rgba(238, 238, 238, 0.93)`,
    };
};
export default {
    iconContainer,
    card,
    notificationBody,
    grayContainerWithBorder,
    progressMobileContainer,
};
